import React from 'react';
import { Form } from 'react-bootstrap';

interface AccommodationInputTextProps {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  HandleChange: (event: any) => void;
  InputClassName?: string;
  InputId: string;
  InputName?: string;
  InputValue?: string;
  LabelText: string;
  IsRequired?: boolean;
  IsTextarea?: boolean;
  Disbled?: boolean;
}

const AccommodationInputText = ({
  HandleChange,
  InputClassName = null,
  InputId,
  InputName = null,
  InputValue = null,
  IsRequired = true,
  IsTextarea = false,
  LabelText,
  Disbled = false,
}: AccommodationInputTextProps) => {
  return (
    <Form.Group className="mb-24">
      <Form.Label className={IsRequired ? 'required' : ''} htmlFor={InputId}>
        {LabelText}
      </Form.Label>
      <Form.Control
        disabled={Disbled}
        as={IsTextarea ? 'textarea' : 'input'}
        autoComplete="off"
        className={InputClassName}
        id={InputId}
        required={IsRequired}
        value={InputValue ?? ''}
        onChange={HandleChange}
        name={InputName !== null ? InputName : InputId}
      />
    </Form.Group>
  );
};

// AccommodationInputText.defaultProps = {
//   InputClassName: null,
//   InputName: null,
//   InputValue: null,
//   IsRequired: true,
//   IsTextarea: false,
// };

export default AccommodationInputText;
export { AccommodationInputText };
export type { AccommodationInputTextProps };
